module.exports = __webpack_public_path__ + "static/media/25588002_1703511643057353_7461245587135763744_o.ef474bcc.jpg";